function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.5 0h24v24H.5V0z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#joyspace_svg__a)",
  fill: "#DEDFDF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.51 7.24c0-.298-.005-.475-.025-.63a3.001 3.001 0 00-2.582-2.584C17.708 4 17.476 4 17.011 4H10.5c.116.104.247.234.462.45l.55.551c.816.816 1.224 1.224 1.711 1.496.269.149.554.267.849.352.537.153 1.114.153 2.268.153h.373c1.779 0 2.956 0 3.797.238z",
  fillOpacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.955 3c.347 0 .522 0 .69.016.72.067 1.404.35 1.961.813.13.107.253.23.5.476l.494.495c.734.734 1.101 1.102 1.54 1.346.242.134.499.24.764.316.484.138 1.004.138 2.041.138h.337c2.369 0 3.554 0 4.323.693.071.063.139.13.202.201.693.77.693 1.956.693 4.324V13.8c0 3.394 0 5.091-1.055 6.145C19.39 21 17.694 21 14.3 21h-3.6c-3.394 0-5.091 0-6.145-1.055C3.5 18.89 3.5 17.194 3.5 13.8V7.455c0-.794 0-1.191.063-1.522a3.6 3.6 0 012.869-2.87C6.764 3.001 7.162 3 7.955 3zm4.76 8c-1.421 0-2.572.948-2.572 2.118 0 .252.054.5.159.734-.12-.02-.246-.029-.374-.029-1.064 0-1.928.712-1.928 1.59C8 16.288 8.864 17 9.928 17h4.5C15.85 17 17 16.052 17 14.882c0-.927-.724-1.714-1.73-2.002-.143-1.057-1.233-1.88-2.555-1.88z"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "joyspace_svg__clip0_1352_3986"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.5)",
  d: "M0 0h24v24H0z"
})));

var SvgJoyspace = function SvgJoyspace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#joyspace_svg__clip0_1352_3986)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "joyspace_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _ref), _ref2), _ref3);
};

export default SvgJoyspace;